import { Link } from "react-router-dom";

// Minimal outline button — works as router link or external link
export const OutlineButton = ({
  to,
  href,
  children,
  testId,
  className = "",
}) => {
  const classes = `group inline-flex items-center justify-center px-12 py-4 border border-aveden-gold/60 text-aveden-white font-sans text-[12px] tracking-[0.3em] uppercase transition-all duration-500 hover:bg-aveden-gold hover:text-aveden-black hover:border-aveden-gold ${className}`;

  if (href) {
    return (
      <a href={href} data-testid={testId} className={classes}>
        {children}
      </a>
    );
  }
  return (
    <Link to={to} data-testid={testId} className={classes}>
      {children}
    </Link>
  );
};

export default OutlineButton;
